/* Native scrolling; no autoplay. Remains scrollable without JavaScript. */
if (!customElements.get('vv-product-rail')) {
  class VvProductRail extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.vv-product-rail__track');
      this.controls = this.querySelector('.vv-product-rail__controls');
      this.count = this.querySelector('.vv-product-rail__count');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      if (!this.track || !this.controls) return;
      this.items = [...this.track.children];
      this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const direction = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
        if (direction) { event.preventDefault(); this.move(direction); }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'instant' });
        }
      }, options);
      this.observer = new ResizeObserver(() => this.scheduleUpdate());
      this.observer.observe(this.track);
      this.update();
      this.classList.add('is-ready');
    }
    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }
    move(direction) {
      if (!this.items.length) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = this.items[0].getBoundingClientRect().width + gap;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * distance, behavior: reduced ? 'instant' : 'smooth' });
    }
    update() {
      const box = this.track.getBoundingClientRect();
      if (!box.width) return; // Hidden favorites panels are remeasured by ResizeObserver when shown.
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.controls.hidden = !overflow;
      const visible = this.items.map((item, index) => {
        const rect = item.getBoundingClientRect();
        const overlap = Math.min(rect.right, box.right) - Math.max(rect.left, box.left);
        return overlap >= rect.width * .9 ? index + 1 : 0;
      }).filter(Boolean);
      if (visible.length) this.count.textContent = `${visible[0]}${visible.length > 1 ? '–' + visible[visible.length - 1] : ''} / ${this.items.length}`;
      this.buttons[0].disabled = this.track.scrollLeft <= 2;
      this.buttons[1].disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }
  customElements.define('vv-product-rail', VvProductRail);
}
